export default __webpack_public_path__ + "static/media/hero_title_two_mobile.51e7504a.svg";